<template>
    <div>
        <button class="btn btn-sm btn-outline-primary font-weight-bolder my-auto"
                data-toggle="modal"
                data-target="#add-crew-medical"
        >
            <span class="fas fa-file-medical"></span>
            Add Medical Record
        </button>

        <!-- ADD Document Modal -->
        <div class="modal fade px-2" id="add-crew-medical" tabindex="-1" role="dialog" aria-labelledby="add-crew-medical-title" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="add-crew-medical-title font-weight-bolder">Add New Medical Record</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-add-crew-medical">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-small">
                        <div class="row">
                            <div class="col-sm-4">
                                <form class="form-group" @submit.prevent="confirmUploadMedical">
                                    <table class="col-table-2 table-sm w-100">

                                        <tr :class="{'has-error': newCrewMedicalError.document_id}">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-document_id"
                                                >
                                                    Medical Type:
                                                </label>
                                            </th>
                                            <td>
                                                <select id="new-document_id" required
                                                        class="form-control form-control-sm"
                                                        v-model="newCrewMedical.document_id"
                                                >
                                                    <option :value="''">--- Select Type ---</option>
                                                    <option v-for="medicalKey in medicalKeys" :key="medicalKey.id"
                                                            :value="medicalKey.id"
                                                    >{{ medicalKey.name }}</option>
                                                </select>
                                                <span class="help-block" v-if="newCrewMedicalError.document_id !== ''">
                                                    <small><strong>{{ newCrewMedicalError.document_id }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.clinic_id}" v-if="crewIsFilipino">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-clinic_id"
                                                >
                                                    Medical Clinic:
                                                </label>
                                            </th>
                                            <td>
                                                <select class="form-control form-control-sm" id="new-clinic_id"
                                                        v-model="newCrewMedical.clinic_id"
                                                >
                                                    <option :value="''">--- SELECT CLINIC ---</option>
                                                    <option v-for="clinicKey in clinicKeys"
                                                            :key="clinicKey.id"
                                                            :value="clinicKey.id"
                                                    >{{ clinicKey.name }}</option>
                                                </select>
                                                <span class="help-block" v-if="newCrewMedicalError.clinic_id !== ''">
                                                    <small><strong>{{ newCrewMedicalError.clinic_id }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.other_clinic}" v-else>
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-other-clinic"
                                                >
                                                    Other Clinic:
                                                </label>
                                            </th>
                                            <td>
                                                <input type="text" id="new-other-clinic"
                                                       class="form-control form-control-sm"
                                                       placeholder="Enter Clinic Name"
                                                       v-model="newCrewMedical.other_clinic"
                                                >
                                                <span class="help-block" v-if="newCrewMedicalError.other_clinic !== ''">
                                                    <small><strong>{{ newCrewMedicalError.other_clinic }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.fitness_date}">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-fitness_date"
                                                >
                                                    Fitness Date:
                                                </label>
                                            </th>
                                            <td>
                                                <input type="date" id="new-fitness_date"
                                                       class="form-control form-control-sm"
                                                       v-model="newCrewMedical.fitness_date"
                                                >
                                                <span class="help-block" v-if="newCrewMedicalError.fitness_date !== ''">
                                                    <small><strong>{{ newCrewMedicalError.fitness_date }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.issued_date}">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-issued_date"
                                                >
                                                    Issued Date:
                                                </label>
                                            </th>
                                            <td>
                                                <input type="date" id="new-issued_date"
                                                       class="form-control form-control-sm"
                                                       v-model="newCrewMedical.issued_date"
                                                >
                                                <span class="help-block" v-if="newCrewMedicalError.issued_date !== ''">
                                                    <small><strong>{{ newCrewMedicalError.issued_date }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.expiry_date}">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-expiry_date"
                                                >
                                                    Expiry Date:
                                                </label>
                                            </th>
                                            <td>
                                                <input type="date" id="new-expiry_date"
                                                       class="form-control form-control-sm"
                                                       v-model="newCrewMedical.expiry_date"
                                                >
                                                <span class="help-block" v-if="newCrewMedicalError.expiry_date !== ''">
                                                    <small><strong>{{ newCrewMedicalError.expiry_date }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.diagnosis}">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-diagnosis"
                                                >
                                                    Diagnosis:
                                                </label>
                                            </th>
                                            <td>
                                                <input type="text" id="new-diagnosis"
                                                       class="form-control form-control-sm"
                                                       placeholder="Enter Medical Diagnosis"
                                                       v-model="newCrewMedical.diagnosis"
                                                >
                                                <span class="help-block" v-if="newCrewMedicalError.diagnosis !== ''">
                                                    <small><strong>{{ newCrewMedicalError.diagnosis }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.medical_recommendation_id}">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-medical_recommendation_id"
                                                >
                                                    Recommendation:
                                                </label>
                                            </th>
                                            <td>
                                                <select class="form-control form-control-sm" id="new-medical_recommendation_id"
                                                        v-model="newCrewMedical.medical_recommendation_id"
                                                >
                                                    <option :value="''">--- SELECT RECOMMENDATION ---</option>
                                                    <option v-for="medicalRecommendationKey in medicalRecommendationKeys"
                                                            :key="medicalRecommendationKey.id"
                                                            :value="medicalRecommendationKey.id"
                                                    >{{ medicalRecommendationKey.name }}</option>
                                                </select>
                                                <span class="help-block" v-if="newCrewMedicalError.medical_recommendation_id !== ''">
                                                    <small><strong>{{ newCrewMedicalError.medical_recommendation_id }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>HBA Test:</th>
                                            <td>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" name="hba" id="new-yes" value="1" v-model="newCrewMedical.hba_test">
                                                    <label class="form-check-label" for="new-yes">YES</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" name="hba" id="new-no" value="0" v-model="newCrewMedical.hba_test">
                                                    <label class="form-check-label" for="new-no">NO</label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr :class="{'has-error': newCrewMedicalError.remarks}">
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-remarks"
                                                >
                                                    Remarks:
                                                </label>
                                            </th>
                                            <td>
                                                <textarea rows="3" class="form-control" id="new-remarks"
                                                          v-model="newCrewMedical.remarks"
                                                ></textarea>
                                                <span class="help-block" v-if="newCrewMedicalError.remarks !== ''">
                                                    <small><strong>{{ newCrewMedicalError.remarks }}</strong></small>
                                                </span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>
                                                <label class="font-weight-bolder text-left form-label-sm"
                                                       for="new-medicalFile"
                                                >
                                                    Upload File:
                                                </label>
                                            </th>
                                            <td>
                                                <div class="custom-file">
                                                    <div id="crewMedicalContainer">
                                                        <input type="file" class="custom-file-input" id="new-medicalFile"
                                                               accept="application/pdf"
                                                               @change="updateFileFrame"
                                                        >
                                                    </div>
                                                    <label class="custom-file-label" for="new-medicalFile">Choose file</label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td></td>
                                            <td class="text-right">
                                                <button type="button" class="btn btn-secondary btn-sm mr-3" data-dismiss="modal">
                                                    <i class="fas fa-times"></i>
                                                    Close
                                                </button>
                                                <button type="submit" class="btn btn-primary btn-sm">
                                                    <i class="fas fa-save"></i>
                                                    Save changes
                                                </button>
                                            </td>
                                        </tr>

                                    </table>
                                </form>
                            </div>
                            <div class="col-sm-6 pb-8">
                                <iframe frameborder="0"
                                        height="600" width="950"
                                        id="newFileFrame" v-if="withUploadedFile"></iframe>
                                <div class="alert alert-warning" role="alert" id="prompt-alert" v-else>
                                    NO UPLOADED DOCUMENT
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { vueAppMixin } from "@/mixins/vueAppMixin";
import { vesselMixin } from "@/mixins/vesselMixin";
import { gateMixin } from "@/mixins/gateMixin";
import {mapActions, mapGetters} from "vuex";
import {formMixin} from "@/mixins/formMixin";

export default {
    name: "AddMedical",

    mixins: [ vueAppMixin, formMixin, vesselMixin, gateMixin ],

    data() {
        return {
            newCrewMedicalError: {
                diagnosis: '',
                remarks: '',
                fitness_date: '',
                issued_date: '',
                expiry_date: '',
                hba_test: '',
                document_id: '',
                clinic_id: '',
                medical_recommendation_id: '',
                other_clinic: ''
            },
            withUploadedFile: false
        }
    },

    methods: {
        ...mapActions([ 'getMedicalKeys', 'getClinicKeys', 'getMedicalRecommendationKeys', 'uploadCrewMedical' ]),

        async initializeData() {
            await this.getMedicalKeys();
            await this.getClinicKeys();
            await this.getMedicalRecommendationKeys();
        },

        async confirmUploadMedical() {
            if(await this.confirmCreateAlert()) {
                let formData = new FormData();
                Object.keys(this.newCrewMedical).forEach(key => {
                    let value = this.newCrewMedical[key] ? this.newCrewMedical[key] : '';
                    formData.append(key, value);
                });
                let medicalFile = document.getElementById('new-medicalFile');
                if (medicalFile.files && medicalFile.files[0]) {
                    let file = medicalFile.files[0];
                    formData.append('medicalFile', file);
                }
                formData.append('crew_id', this.crew.id);
                let additionalCrewMedical = await this.uploadCrewMedical(formData);
                if(additionalCrewMedical) {
                    if(additionalCrewMedical.errors) {
                        this.newCrewMedicalError = additionalCrewMedical.errors;
                    } else {
                        this.successAlert('Crew Medical Successfully Added', 'UPLOAD');
                        this.clearIframe();
                        this.newCrewMedicalError = {
                            diagnosis: '',
                            remarks: '',
                            fitness_date: '',
                            hba_test: '',
                            document_id: '',
                            clinic_id: '',
                            medical_recommendation_id: ''
                        }
                        this.refreshInputFile('crewMedicalContainer');
                        document.getElementById('close-add-crew-medical').click();
                    }
                }
            }
        },

        updateFileFrame() {
            let input = document.getElementById('new-medicalFile');
            if (input.files && input.files[0]) {
                if(input.files[0].size > 1000000) {
                    document.getElementById('prompt-alert').innerText = 'FILE TOO LARGE';
                    this.clearIframe();
                    this.withUploadedFile = false;
                    return;
                } else {
                    document.getElementById('prompt-alert').innerText = '';
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        document.getElementById('newFileFrame').src  = e.target.result + "#zoom=80";
                    };
                    reader.readAsDataURL(input.files[0]);
                    this.withUploadedFile = true;
                }
            }
        },

        clearIframe() {
            document.getElementById('newFileFrame').src  = "";
        },

    },

    computed: {
        ...mapGetters([ 'newCrewMedical', 'medicalKeys', 'clinicKeys', 'medicalRecommendationKeys', 'crew' ])
    },

    created() {
        this.initializeData();
    }

}
</script>

<style scoped>

</style>
